
import * as React from 'react';
import { withCurrentItemSet, IDecorateWithCurrentItemSetProps } from '../decorators/selectors';
import { withPageLoadTracker, IDecorateWithPageLoadTrackerProps } from '../decorators/withPageLoadTracker';
import { EmptyFolder, IEmptyFolderProps } from './EmptyFolder';
import { childItemsFacet } from '../../facets/SetFacets';

export type IItemsEmptyFolderProps = IDecorateWithCurrentItemSetProps<IDecorateWithPageLoadTrackerProps<IEmptyFolderProps>>;

export const ItemsEmptyFolder: React.ComponentType<IItemsEmptyFolderProps> = withCurrentItemSet()(
  withPageLoadTracker([childItemsFacet])(EmptyFolder)
);
